(function () {
  var FORM_ID = 'XJmtbP';
  var submitted = false;

  function openSpinForm() {
    window._klOnsite = window._klOnsite || [];
    if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
      window.klaviyo.openForm(FORM_ID);
    } else {
      window._klOnsite.push(['openForm', FORM_ID]);
    }
  }

  function fillEmail(email) {
    var klForm = document.querySelector(
      '[data-testid="klaviyo-form-' + FORM_ID + '"]'
    );
    var input =
      klForm &&
      klForm.querySelector('input[name="email"], input[type="email"]');
    if (!input) return false;

    var setter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      'value'
    ).set;
    setter.call(input, email);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function syncConsentFromFooter() {
  var footerChecked = !!document.querySelector(
    '#footer-newsletter input[name="policy"]:checked'
  );
  if (!footerChecked) return false;

  var klForm = document.querySelector(
    '[data-testid="klaviyo-form-' + FORM_ID + '"]'
  );
  var box = klForm && klForm.querySelector('input[type="checkbox"]');
  if (!box) return false;
  if (box.checked) return true;

  var setter = Object.getOwnPropertyDescriptor(
    window.HTMLInputElement.prototype,
      'checked'
    ).set;
    setter.call(box, true);
    box.dispatchEvent(new Event('click', { bubbles: true }));
    box.dispatchEvent(new Event('input', { bubbles: true }));
    box.dispatchEvent(new Event('change', { bubbles: true }));

    if (!box.checked) box.click();

    return box.checked;
  }

  function prefill(email) {
    function done() {
      var emailOk = fillEmail(email);
      var consentOk = syncConsentFromFooter();
      return emailOk && consentOk;
    }

    if (done()) return;

    var n = 0;
    var id = setInterval(function () {
      n += 1;
      if (done() || n > 40) clearInterval(id);
    }, 250);
  }

  function showFooterSuccess() {
    var form = document.getElementById('footer-newsletter');
    if (!form) return;

    var success = document.getElementById('footer-newsletter-success');
    var emailWrap = form.querySelector('.form-control');

    if (emailWrap) emailWrap.style.display = 'none';
    if (success) success.hidden = false;
  }

  function handle(e, form) {
    var email = (
      (form.querySelector('input[type="email"]') || {}).value || ''
    ).trim();
    var policy = form.querySelector('input[name="policy"]');

    if (!email) return;

    if (policy && !policy.checked) {
      if (policy.reportValidity) policy.reportValidity();
      return;
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    openSpinForm();
    prefill(email);
  }

  /*function onKlaviyoForms(event) {
    var detail = event.detail || {};
    if (detail.formId !== FORM_ID) return;

    if (detail.type === 'submit') {
      submitted = true;
      showFooterSuccess();
    }

    if (detail.type === 'close' && submitted) {
      showFooterSuccess();
    }
  }*/
 function onKlaviyoForms(event) {
  var detail = event.detail || {};
  if (detail.formId !== FORM_ID) return;

  if (detail.type === 'submit') {
    submitted = true;
  }

  if (detail.type === 'close' && submitted) {
    showFooterSuccess();
  }
}

  function init() {
    window.addEventListener('klaviyoForms', onKlaviyoForms);

    var form = document.getElementById('footer-newsletter');
    if (!form) return;

    form.addEventListener(
      'submit',
      function (e) {
        handle(e, form);
      },
      true
    );

    var btn = form.querySelector('button[type="submit"]');
    if (btn) {
      btn.addEventListener(
        'click',
        function (e) {
          handle(e, form);
        },
        true
      );
    }

    var emailInput = form.querySelector('input[type="email"]');
    if (emailInput) {
      emailInput.addEventListener(
        'keydown',
        function (e) {
          if (e.key === 'Enter') handle(e, form);
        },
        true
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();